module.exports = __webpack_public_path__ + "img/update3.5_image06.bb59d29b.png";